/**
 * Member-facing names for attachments. Files are named by TYPE, not by their
 * original file name (which is usually a screenshot UUID). Mirrors the backend
 * `attachment_lines.type_name` so web chat and SMS say the same thing.
 */

const DOC_NAMES = {
  pdf: 'PDF',
  ppt: 'PowerPoint',
  pptx: 'PowerPoint',
  doc: 'Word file',
  docx: 'Word file',
  xls: 'Excel file',
  xlsx: 'Excel file',
  csv: 'Excel file',
  txt: 'Text file',
  md: 'Text file'
};

export const attachmentExtension = (att) => {
  const name = String(att?.filename || att?.url || '').split('?')[0];
  const m = name.match(/\.([a-z0-9]+)$/i);
  return m ? m[1].toLowerCase() : '';
};

export const attachmentTypeName = (att) => {
  if (!att) return 'File';
  if (att.type === 'image') return 'Image';
  if (att.type === 'video') return 'Video';
  return DOC_NAMES[attachmentExtension(att)] || 'File';
};

/** Label if the admin set one, otherwise the type name. */
export const attachmentDisplayName = (att) =>
  (att?.label && String(att.label).trim()) || attachmentTypeName(att);

/** Names for a list, numbering repeats of the same kind ("Image 1", "Image 2"). */
export const attachmentDisplayNames = (attachments) => {
  const names = (attachments || []).map(attachmentDisplayName);
  const counts = names.reduce((acc, n) => ({ ...acc, [n]: (acc[n] || 0) + 1 }), {});
  const seen = {};
  return names.map((n) => {
    if (counts[n] > 1) {
      seen[n] = (seen[n] || 0) + 1;
      return `${n} ${seen[n]}`;
    }
    return n;
  });
};
